if (!customElements.get('td-tooltip')) {
  class TdTooltip extends HTMLElement {
    constructor() {
      super();
      this.arrow = null;
      this.active = false;
      this.onMouseEnter = this.onMouseEnter.bind(this);
      this.onMouseLeave = this.onMouseLeave.bind(this);
    }

    connectedCallback() {
      this.arrow = this.querySelector('.tooltip-arrow');
      const activatorSelector = this.getAttribute('activator');
      if (activatorSelector) {
        this.activator = this.closest('.td-material-information__feature-icons-wrapper')?.querySelector(activatorSelector);
      }
      this.wrapper = this.closest('.td-material-information__feature-icons-wrapper');
      this.setupEvents();
    }

    disconnectedCallback() {
      this.removeEvents();
    }

    setupEvents() {
      if (!this.activator) return;
      this.activator.addEventListener('mouseenter', this.onMouseEnter);
      this.activator.addEventListener('mouseleave', this.onMouseLeave);
    }

    removeEvents() {
      if (!this.activator) return;
      this.activator.removeEventListener('mouseenter', this.onMouseEnter);
      this.activator.removeEventListener('mouseleave', this.onMouseLeave);
    }

    onMouseEnter() {
      this.classList.add('active');
      // Dynamic arrow positioning
      if (this.activator && this.wrapper && this.arrow) {
        const iconRect = this.activator.getBoundingClientRect();
        const tooltipRect = this.getBoundingClientRect();
        const iconCenter = iconRect.left + iconRect.width / 2;
        const tooltipLeft = tooltipRect.left;
        const arrowLeft = iconCenter - tooltipLeft;
        this.style.setProperty('--arrow-left', `${arrowLeft}px`);
      }
    }

    onMouseLeave() {
      this.classList.remove('active');
      this.style.removeProperty('--arrow-left');
    }
  }
  customElements.define('td-tooltip', TdTooltip);
}
